import type {Shift} from "@/src/modules/shifts/types";

export {
  dispatchCenterRequiresShift,
  isDispatchOperatorRole,
  showDispatchPersonalShiftBlock,
} from "@/src/modules/core/lib/dispatch-center-policy";

/** Desk body + property lookup stay locked until personal shift is active. */
export function isDispatchDeskShiftLocked(
  showPersonalShift: boolean,
  activeShiftPending: boolean,
  activeShift: Shift | null | undefined,
): boolean {
  return showPersonalShift && !activeShiftPending && activeShift == null;
}
